/**
 * User modules
 */

export const MODULE_ROOT = "root"; // Module for roots
export const MODULE_TIM = "tim"; // Module for stores
export const MODULE_LCM = "lcm"; // Module for buyers
export const MODULE_RPS = "rps"; // Module for warehouses
export const NO_MODULE_TYPE = "no_module_type";

/**
 * User types
 *
 * IMPORTANT: If you change a constant value don't forget to update its translation in src/assets/i18n/!**!/enums.json
 */
export const ADMIN = "admin";
export const SUPER_ADMIN = "super_admin";
export const ROOT_MANAGEMENT_UNIT_MANAGER = "root_management_unit_manager";
export const ROOT_MANAGEMENT_UNIT_ANALYST = "root_management_unit_analyst";
export const MANAGEMENT_UNIT_MANAGER = "management_unit_manager";
export const MANAGEMENT_UNIT_ANALYST = "management_unit_analyst";
export const STORE_MANAGER = "store_manager";
export const STORE_SELLER = "store_seller";
export const WAREHOUSE_MANAGER = "warehouse_manager";
export const WAREHOUSE_OPERATOR = "warehouse_operator";
export const BUYER_MANAGER = "buyer_manager";
export const PSEUDO_ANONYMOUS = "pseudo_anonymous";

export const USER_ROOT_TYPES = [ROOT_MANAGEMENT_UNIT_MANAGER, ROOT_MANAGEMENT_UNIT_ANALYST];
export const USER_MANAGEMENT_UNIT_TYPES = [MANAGEMENT_UNIT_MANAGER, MANAGEMENT_UNIT_ANALYST];
export const USER_STORE_TYPES = [STORE_MANAGER, STORE_SELLER];
export const USER_TIM_TYPES = [...USER_MANAGEMENT_UNIT_TYPES, ...USER_STORE_TYPES];
export const USER_LCM_TYPES = [BUYER_MANAGER];
export const USER_RPS_TYPES = [WAREHOUSE_MANAGER, WAREHOUSE_OPERATOR];
export const ADMIN_USER_TYPES = [ADMIN, SUPER_ADMIN];
export const NON_ADMIN_USER_TYPES = [...USER_ROOT_TYPES, ...USER_TIM_TYPES, ...USER_LCM_TYPES, ...USER_RPS_TYPES];
export const USER_TYPES = [...ADMIN_USER_TYPES, ...NON_ADMIN_USER_TYPES];

/**
 * User permissions
 */
export const ROLE_INNER = "ROLE_CIRCULARX";
export const ROLE_ALLOWED_TO_SWITCH = "ROLE_ALLOWED_TO_SWITCH";
export const ROLE_BUYBACK_MENU = "ROLE_BUYBACK_MENU";
export const ROLE_CATALOG_SUBMENU = "ROLE_CATALOG_SUBMENU";
export const ROLE_BUYBACK_SUBMENU = "ROLE_BUYBACK_SUBMENU";
export const ROLE_CONFIGURATION_MENU = "ROLE_CONFIGURATION_MENU";
export const ROLE_SETTINGS_SUBMENU = "ROLE_SETTINGS_SUBMENU";
export const ROLE_GENERAL_SETTINGS_PAGE = "ROLE_GENERAL_SETTINGS_PAGE";
export const ROLE_TRANSFER_ORDER_SETTINGS_PAGE = "ROLE_TRANSFER_ORDER_SETTINGS_PAGE";
export const ROLE_ORGANIZATION_SUBMENU = "ROLE_ORGANIZATION_SUBMENU";
export const ROLE_ADMIN_MENU = "ROLE_ADMIN_MENU";
export const ROLE_CATEGORY_LIST_PAGE = "ROLE_CATEGORY_LIST_PAGE";
export const ROLE_CATEGORY_UPDATE_PAGE = "ROLE_CATEGORY_UPDATE_PAGE";
export const ROLE_CATEGORY_CREATE_PAGE = "ROLE_CATEGORY_CREATE_PAGE";
export const ROLE_PRODUCT_LIST_PAGE = "ROLE_PRODUCT_LIST_PAGE";
export const ROLE_PRODUCT_CREATE_PAGE = "ROLE_PRODUCT_CREATE_PAGE";
export const ROLE_PRODUCT_UPDATE_PAGE = "ROLE_PRODUCT_UPDATE_PAGE";
export const ROLE_QUESTION_LIST_PAGE = "ROLE_QUESTION_LIST_PAGE";
export const ROLE_QUESTION_UPDATE_PAGE = "ROLE_QUESTION_UPDATE_PAGE";
export const ROLE_BUYBACK_LIST_PAGE = "ROLE_BUYBACK_LIST_PAGE";
export const ROLE_BUYBACK_PREDECLARED_CHECK_PAGE = "ROLE_BUYBACK_PREDECLARED_CHECK_PAGE";
export const ACCESS_PREDECLARED_BUYBACKS = "ACCESS_PREDECLARED_BUYBACKS";
export const ROLE_BUYBACK_DETAIL_PAGE = "ROLE_BUYBACK_DETAIL_PAGE";
export const ROLE_BUYBACK_CREATE_SEARCH_PAGE = "ROLE_BUYBACK_CREATE_SEARCH_PAGE";
export const ROLE_BUYBACK_CREATE_PAGE = "ROLE_BUYBACK_CREATE_PAGE";
export const ROLE_BUYBACKITEM_SEND_PAGE = "ROLE_BUYBACKITEM_SEND_PAGE";
export const ROLE_BUYBACKITEM_CONTROL_PAGE = "ROLE_BUYBACKITEM_CONTROL_PAGE";
export const ROLE_CLIENT_LIST_PAGE = "ROLE_CLIENT_LIST_PAGE";
export const ROLE_CLIENT_UPDATE_PAGE = "ROLE_CLIENT_UPDATE_PAGE";
export const ROLE_CLIENT_CREATE_PAGE = "ROLE_CLIENT_CREATE_PAGE";
export const ROLE_CLIENT_EDIT_CMS_PAGES_PAGE = "ROLE_CLIENT_EDIT_CMS_PAGES_PAGE";
export const ROLE_CLIENT_PAGE = "ROLE_CLIENT_PAGE";
export const ROLE_ORGANIZATION_LIST_PAGE = "ROLE_ORGANIZATION_LIST_PAGE";
export const ROLE_ORGANIZATION_UPDATE_PAGE = "ROLE_ORGANIZATION_UPDATE_PAGE";
export const ROLE_ORGANIZATION_CREATE_PAGE = "ROLE_ORGANIZATION_CREATE_PAGE";
export const ROLE_STORES_FILTER = "ROLE_STORES_FILTER";
export const ROLE_BUYERS_FILTER = "ROLE_BUYERS_FILTER";
export const ROLE_ROOT_MANAGEMENT_LIST_PAGE = "ROLE_ROOT_MANAGEMENT_LIST_PAGE";
export const ROLE_ADMIN_LIST_PAGE = "ROLE_ADMIN_LIST_PAGE";
export const ROLE_USER_LIST_PAGE = "ROLE_USER_LIST_PAGE";
export const ROLE_USER_CREATE_PAGE = "ROLE_USER_CREATE_PAGE";
export const ROLE_USER_UPDATE_PAGE = "ROLE_USER_UPDATE_PAGE";
export const ROLE_CONFIG_PAYMENT_PAGE = "ROLE_CONFIG_PAYMENT_PAGE";
export const ROLE_CONFIG_EXPEDITION_PAGE = "ROLE_CONFIG_EXPEDITION_PAGE";
export const ROLE_DESIGN_PAGE = "ROLE_DESIGN_PAGE";
export const ROLE_PAYMENT_MARK_AS_PAID = "ROLE_PAYMENT_MARK_AS_PAID";
export const ROLE_PAYMENT_MODES_PAGE = "ROLE_PAYMENT_MODES_PAGE";
export const ROLE_PAYMENT_MODE_UPDATE_PAGE = "ROLE_PAYMENT_MODE_UPDATE_PAGE";
export const ROLE_BUYBACKITEM_QUARANTINE_TRANSITION_PAGE = "ROLE_BUYBACKITEM_QUARANTINE_TRANSITION_PAGE";
export const ROLE_EXPORT_BUYBACK_PAGE = "ROLE_EXPORT_BUYBACK_PAGE";
export const ROLE_DISPATCH_CIRCUIT_RULE_LIST_PAGE = "ROLE_DISPATCH_CIRCUIT_RULE_LIST_PAGE";
export const ROLE_DISPATCH_CIRCUIT_RULE_EDIT_PAGE = "ROLE_DISPATCH_CIRCUIT_RULE_EDIT_PAGE";
export const ROLE_TRANSPORT_RETRIEVE_RETURN_LABEL_BUTTON = "ROLE_TRANSPORT_RETRIEVE_RETURN_LABEL_BUTTON";
export const ROLE_ITEM_REFURB_STEP_READ = "ROLE_ITEM_REFURB_STEP_READ";
export const ROLE_CONFIGURATION_CONNECTORS = "role_configuration_connectors";
export const ROLE_WAREHOUSE_CHECKIN_PAGE = "ROLE_WAREHOUSE_CHECKIN_PAGE";
export const ROLE_WAREHOUSE_CHECKIN_SUBMENU = "ROLE_WAREHOUSE_CHECKIN_SUBMENU";
export const ROLE_CAN_READ_PAYMENT_CUSTOM_VALUES = "ROLE_CAN_READ_PAYMENT_CUSTOM_VALUES";
export const ROLE_USER_FORCECONNECTIONBYSSO_FIELD = "ROLE_USER_FORCECONNECTIONBYSSO_FIELD";
export const ROLE_ITEM_MARK_AS_LOST_TRANSPORT = "ROLE_ITEM_MARK_AS_LOST_TRANSPORT";
export const ROLE_ITEM_MARK_AS_LOST_WAREHOUSE = "ROLE_ITEM_MARK_AS_LOST_WAREHOUSE";
export const ROLE_ITEM_MARK_AS_LOST_STORE = "ROLE_ITEM_MARK_AS_LOST_STORE";
export const ROLE_BUYBACK_AWAITING_STORE_DROP_LIST_PAGE = "ROLE_BUYBACK_AWAITING_STORE_DROP_LIST_PAGE";
export const ROLE_WAREHOUSE_DISPATCH_RULE_READ = "ROLE_WAREHOUSE_DISPATCH_RULE_READ";
export const ROLE_WAREHOUSE_DISPATCH_RULE_CREATE = "ROLE_WAREHOUSE_DISPATCH_RULE_CREATE";
export const ROLE_REFURB_STEP_MANAGE = "ROLE_REFURB_STEP_MANAGE";
export const ROLE_REFURB_WRITE = "ROLE_REFURB_WRITE";
export const ROLE_ITEMS_STOCK_READ = "ROLE_ITEMS_STOCK_READ";
export const ROLE_STOCK_MANAGE = "ROLE_STOCK_MANAGE";
export const ROLE_USER_CREATE_ADMIN = "ROLE_USER_CREATE_ADMIN";
export const ROLE_USER_CAN_ASSIGN_ADMIN = "ROLE_USER_CAN_ASSIGN_ADMIN";
export const ROLE_SEND_QUARANTINE_MAIL = "ROLE_SEND_QUARANTINE_MAIL";

// Liste des permissions spécifiques au diagnostique avancé.
export const ROLE_REFURB_DIAGNOSTIC_MANAGE = "ROLE_REFURB_DIAGNOSTIC_MANAGE";
export const ROLE_REFURB_DIAGNOSTIC_WRITE = "ROLE_REFURB_DIAGNOSTIC_WRITE";

// Permission pour faire des imports CSV
export const ROLE_IMPORTS_PAGE = "ROLE_IMPORTS_PAGE";

// Permissions for exports
export const ROLE_EXPORT_PRODUCTS = "ROLE_EXPORT_PRODUCTS";
export const ROLE_EXPORT_CATEGORIES = "ROLE_EXPORT_CATEGORIES";

/**
 * User statuses
 *
 * IMPORTANT: if you change a constant value don't forget to update its translation in src/assets/i18n/!**!/enums.json
 */
export const USER_ACTIVE = "active";
export const USER_INACTIVE = "inactive";
